import * as yup from 'yup';
import _get from 'lodash/get';
import { RenderConfig, SelectInput, Row, DateRangeInput } from 'commons-ui';

import { FORM_FIELD_KEYS, REQUEST_STATUS_OPTIONS, REQUEST_STATUS } from '../constants';

const requestStatusDependencyResolver = (props: any, dependencyValues: any) => {
	const requestStatus = _get(dependencyValues, '0');
	const { disabled } = props;

	if ((requestStatus === REQUEST_STATUS.APPROVED || requestStatus === REQUEST_STATUS.REJECTED) && disabled) {
		return { disabled: false };
	}
	if (requestStatus === REQUEST_STATUS.PENDING && !disabled) {
		return { disabled: true };
	}
	return null;
};

export const validationSchema = yup.object().shape({
	requestStatus: yup.string().required('requestStatus is a required field'),
	dateRange: yup.array().when(['requestStatus'], {
		is: (requestStatus: string) => requestStatus === 'rejected' || requestStatus === 'approved',
		then: yup.array().test({
			message: 'Incomplete date range',
			test: (value: any) => value.length === 2
		})
	})
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.REQUEST_STATUS]: new RenderConfig()
		.setName('requestStatus')
		.setLabel('Request Status')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: REQUEST_STATUS_OPTIONS,
			required: true
		}),
	[FORM_FIELD_KEYS.DATE_RANGE]: new RenderConfig()
		.setName('dateRange')
		.setLabel('Date Range')
		.setRenderer(DateRangeInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			dependencies: ['requestStatus'],
			dependencyResolver: requestStatusDependencyResolver
		})
};

export const FORM_LAYOUT_CONFIG = [new Row(FORM_FIELD_KEYS.REQUEST_STATUS), new Row(FORM_FIELD_KEYS.DATE_RANGE)];
